module.exports = __webpack_public_path__ + "components/app-store/static/s2-265e5ac76335d79356057ca2de6c7186.jpg";